
export const methodList = ['/ticketepb.TicketService/GetLawyerLetterList'];